import { useMemo } from "react";
import OrgStatusTag from "@/features/organization/components/OrgStatusTag";
import { findOrgPathWithStatus } from "./organization.utils";

// Hook for computing org path with status
export const useOrgPathWithStatus = (orgId, orgTree) => {
  const pathWithStatus = useMemo(() => {
    if (!orgId || !orgTree) return [];
    return findOrgPathWithStatus(orgTree, orgId);
  }, [orgId, orgTree]);

  const lastNode =
    pathWithStatus.length > 0
      ? pathWithStatus[pathWithStatus.length - 1]
      : undefined;
  const orgStatus = lastNode?.status;
  const orgInactiveDate = lastNode?.inactiveDate;

  return { pathWithStatus, orgStatus, orgInactiveDate };
};

// Component for displaying org breadcrumb with status badges
const OrgBreadcrumb = ({ pathWithStatus, fallbackLabel, className = "" }) => {
  if (!pathWithStatus || pathWithStatus.length === 0) {
    return fallbackLabel ? (
      <span
        className={`text-[11px] leading-5 text-muted-foreground ${className}`}
      >
        {fallbackLabel}
      </span>
    ) : null;
  }

  return (
    <div
      className={`inline-flex flex-wrap items-center gap-0.5 text-[10px] text-muted-foreground ${className}`}
    >
      {pathWithStatus.map((node, idx) => (
        <span
          key={`${node.id}-${idx}`}
          className="inline-flex items-center gap-0.5"
        >
          {idx > 0 && <span className="px-0.5">/</span>}
          <span>{node.name}</span>
          <OrgStatusTag
            status={node.status}
            inactiveDate={node.inactiveDate}
            className="text-[9px]"
          />
        </span>
      ))}
    </div>
  );
};

export default OrgBreadcrumb;
